/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Plus, Minus, ShoppingCart } from "lucide-react";
import foodPlaceholder from "../../assets/icon/food-placeholder.svg";
import ProductAddonSelector from "./product-addon-selector";

export const ProductCard = ({ product, onQuantityChange, quantity = 0 }) => {
  const [selectedAddon, setSelectedAddon] = useState("");

  const handleIncrement = (e) => {
    e.stopPropagation();
    const newQuantity = quantity + 1;
    onQuantityChange(product, newQuantity, selectedAddon);
  };

  const handleDecrement = (e) => {
    e.stopPropagation();
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      onQuantityChange(product, newQuantity, selectedAddon);
    }
  };

  const hasValidAddOns = (product) => {
    if (!product.addOn || !Array.isArray(product.addOn)) return false;
    if (product.addOn.length === 1 && product.addOn[0].trim() === '') return false;
    return product.addOn.some(option => option && option.trim() !== '');
  };

  const needsSelection = hasValidAddOns(product);

  const handleAddonSelect = (option) => {
    setSelectedAddon(option);
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col">
      <div className="relative h-48 group overflow-hidden">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105"
            onError={(e) => {
              e.target.src = foodPlaceholder;
            }}
          />
        ) : (
          <img
            src={foodPlaceholder}
            alt="Imagen no disponible"
            className="w-full h-full object-contain p-4"
          />
        )}

        {quantity > 0 && (
          <div className="absolute top-2 right-2">
            <div className="bg-orange-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold shadow-lg">
              {quantity}
            </div>
          </div>
        )}
      </div>

      <div className="p-4 space-y-2 flex flex-col flex-grow">
        <p className="text-orange-500 text-sm line-clamp-1">
          {product.description}
        </p>
        
        {needsSelection && (
          <div className="mt-2 mb-4">
            <p className="text-sm font-medium text-gray-700 mb-2">
              Selecciona una opción:
            </p>
            <ProductAddonSelector
              options={product.addOn.filter(option => option && option.trim() !== '')}
              selectedOption={selectedAddon}
              onOptionSelect={handleAddonSelect}
            />
          </div>
        )}

        <h3 className="text-xl font-bold line-clamp-2">{product.name}</h3>
        <p className="font-semibold text-lg">€ {product.price?.toFixed(2)}</p>

        <div className="mt-auto pt-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <button
              type="button"
              onClick={handleDecrement}
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                quantity === 0
                  ? "bg-gray-100 text-gray-400"
                  : "bg-orange-500 text-white hover:bg-orange-600"
              }`}
              disabled={quantity === 0}
            >
              <Minus className="w-4 h-4" />
            </button>

            <span className="text-xl font-semibold w-8 text-center">
              {quantity}
            </span>

            <button
              type="button"
              onClick={handleIncrement}
              className="w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center hover:bg-orange-600"
              disabled={needsSelection && !selectedAddon}
            >
              <Plus className="w-4 h-4" />
            </button>
          </div>

          {quantity === 0 ? (
            <button
              onClick={handleIncrement}
              type="button"
              className="flex items-center space-x-2 px-4 py-2 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-colors"
              disabled={needsSelection && !selectedAddon}
            >
              <ShoppingCart className="w-4 h-4" />
              <span>Agregar</span>
            </button>
          ) : (
            <div className="text-orange-500 font-semibold">
              € {(product.price * quantity).toFixed(2)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};